// BrimLight/common/schemas/collections/videoGenerationJobs.js
import { z } from "zod";

const VideoGenerationJobSchema = z.object({
    _id: z.string().optional(),
    projectId: z.string(),
    subscriptionId: z.string(),
    
    status: z.enum([
        "queued",
        "in_progress",
        "completed",
        "failed",
        "cancelled"
    ]).default("queued"),
    
    progress: z.number().int().min(0).max(100).default(0),
    progressMessage: z.string().optional().nullable(),
    
    finalVideoRelativePath: z.string().optional().nullable(),
    
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    completedAt: z.coerce.date().optional().nullable(),
});

export default VideoGenerationJobSchema;